<template>
    <div class="d-flex justify-content-between align-items-center">
        <em>n/a</em>
        <button class="btn btn-sm btn-outline-secondary" v-on:click="open">
            <i class="fa fa-car-side"></i>
        </button>
        <div class="modal" ref="modal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <form class="modal-content" v-on:submit.prevent="submit">
                    <div class="block block-rounded block-transparent mb-0">
                        <div class="block-header block-header-default">
                            <h3 class="block-title">Select Existing Vehicle and Job</h3>
                            <div class="block-options">
                                <button type="button" class="btn-block-option" data-bs-dismiss="modal" aria-label="Close">
                                    <i class="fa fa-fw fa-times"></i>
                                </button>
                            </div>
                        </div>
                        <div v-if="loading" class="block-content text-center">
                            <p class="h4 mb-4">Loading</p>
                        </div>
                        <div v-else class="block-content fs-sm">
                            <div class="mb-4">
                                <label class="form-label" for="f_vehicle">Vehicle (required)</label>
                                <select class="form-select" id="f_vehicle" ref="vehiclePicker" required>
                                </select>
                            </div>
                            <div class="mb-4">
                                <label class="form-label" for="f_job">Job (optional)</label>
                                <select class="form-select" id="f_job" ref="jobPicker" :disabled="chosenVehicle === null">
                                </select>
                            </div>
                        </div>
                        <div class="block-content block-content-full text-end bg-body">
                            <button type="button" class="btn btn-sm btn-alt-secondary me-1" data-bs-dismiss="modal">Close</button>
                            <button v-if="!loading" type="submit" class="btn btn-sm btn-success">Assign</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import Modal from 'bootstrap/js/dist/modal';
import { Eventbus } from '@/components/eventbus';

export default {
    props: {
        uuid: String,
        routes: Object,
    },
    data() {
        return {
            chosenVehicle: null,
            chosenJob: null,
            initialisedSelect2: false,
            loading: false,
        };
    },
    mounted () {
        this.modal = new Modal(this.$refs.modal);
    },
    methods: {
        open () {
            this.modal.show();

            if (! this.initialisedSelect2) {
                window.jQuery(this.$refs.vehiclePicker).select2({
                    dropdownParent: this.$refs.modal,
                    placeholder: 'Select vehicle',
                    allowClear: true,
                    ajax: {
                        cache: true,
                        data: function(params) {
                            return {
                                search: params.term,
                                page: params.page
                            };
                        },
                        dataType: 'json',
                        delay: 250,
                        processResults: function(data) {
                            // why do we need to do this?
                            return {
                                results: data.data
                            };
                        },
                        url: this.routes.vehicleFilter,
                    }
                }).on('select2:select', (ev) => {
                    this.chosenVehicle = ev.params.data.id;
                    window.jQuery(this.$refs.jobPicker).val(null).trigger('change');
                }).on('select2:clear', (ev) => {
                    this.chosenVehicle = null;
                    window.jQuery(this.$refs.jobPicker).val(null).trigger('change');
                });

                window.jQuery(this.$refs.jobPicker).select2({
                    dropdownParent: this.$refs.modal,
                    placeholder: 'Select job',
                    allowClear: true,
                    ajax: {
                        cache: true,
                        data: function(params) {
                            return {
                                search: params.term,
                                page: params.page
                            };
                        },
                        dataType: 'json',
                        delay: 250,
                        processResults: function(data) {
                            // why do we need to do this?
                            return {
                                results: data.data
                            };
                        },
                        url: () => {
                            return this.routes.jobsFilter.replace('replace-me', this.chosenVehicle);
                        },
                    }
                }).on('select2:select', (ev) => {
                    this.chosenJob = ev.params.data.id;
                }).on('select2:clear', (ev) => {
                    this.chosenJob = null;
                });

                this.initialisedSelect2 = true;
            }
        },
        submit () {
            axios.post(this.routes.assignToVehicle.replace('replace-me', this.uuid), {
                chosenJob: this.chosenJob,
                chosenVehicle: this.chosenVehicle,
            }).then((response) => {
                Eventbus.emit('time-entries-table-refresh');
                this.modal.hide();
            }).catch((error) => {
                alert('Unable to submit');
                console.log(error)
            });
        }
    }
}
</script>
